<h2 class="title" *ngIf="formType === 'recipient'">Edit Recipient</h2>
<h2 class="title" *ngIf="formType === 'donor'">Edit Donor</h2>

<mat-dialog-content>
  <!-- app.component.html -->
  <div class="form-container">
    <!-- Donor Form -->
    <form *ngIf="formType === 'donor' && donorForm" [formGroup]="donorForm" (ngSubmit)="editDonor()">
      <mat-form-field appearance="fill">
        <mat-label>ENIS Number</mat-label>
        <input matInput formControlName="enisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
        <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('required')"> ENIS Number is required </mat-error>
        <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('pattern') && !donorForm.get('enisNumber')?.hasError('required')"> ENIS Number must contain only digits </mat-error>
        <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('minlength') && !donorForm.get('enisNumber')?.hasError('required') && !donorForm.get('enisNumber')?.hasError('pattern')">
          ENIS Number must be at least 5 digits long
        </mat-error>
        <mat-error
          *ngIf="
            donorForm.get('enisNumber')?.hasError('maxlength') &&
            !donorForm.get('enisNumber')?.hasError('required') &&
            !donorForm.get('enisNumber')?.hasError('pattern') &&
            !donorForm.get('enisNumber')?.hasError('minlength')
          "
        >
          ENIS Number must be at most 6 digits long
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Date of Birth</mat-label>
        <input matInput [matDatepicker]="dobpicker1" min="1900-01-01" formControlName="dob" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="dobpicker1"></mat-datepicker-toggle>
        <mat-datepicker #dobpicker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" placeholder="firstName" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" placeholder="lastName" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Gender</mat-label>
        <mat-select matInput formControlName="gender">
          <mat-option value="M">Male</mat-option>
          <mat-option value="F">Female</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Center</mat-label>
        <mat-select formControlName="center" placeholder="Select a center">
          <mat-option *ngFor="let center of assignableCenters" [value]="center">
            {{ center.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Blood Type</mat-label>
        <mat-select matInput formControlName="abo">
          <mat-option value="O">O</mat-option>
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="AB">AB</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>HLA Class I</mat-label>
        <input matInput formControlName="hlaClassI" placeholder="A1 A1 A*01:01 A*01:01 B17 B57 B*57:01 B37 B*37:01 Bw4 Cw6 Cw6 C*06:02 C*06:02" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>HLA Class II</mat-label>
        <input matInput formControlName="hlaClassII" placeholder="DR1 DR13 DRB1*01:01 DRB1*13:01" />
      </mat-form-field>

      <mat-checkbox formControlName="altruist"> Altruist </mat-checkbox>

      <div *ngIf="donorForm.get('altruist')?.value">
        <mat-checkbox formControlName="active"> Active </mat-checkbox>
      </div>

      <mat-checkbox formControlName="donorPrivileges"> Privileges </mat-checkbox>

      <div *ngIf="donorForm.get('donorPrivileges')?.value" class="additional-options">
        <br />

        <mat-form-field appearance="fill">
          <mat-label>Limited to Centers</mat-label>
          <mat-select formControlName="limitedToCenter" multiple>
            <mat-option *ngFor="let center of assignableCenters" [value]="center">
              {{ center.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox formControlName="donateToWaitlist"> Donate to Waitlist Only </mat-checkbox>
      </div>

      <br />
      <button mat-raised-button color="primary" type="submit">Edit Donor</button>
    </form>

    <!-- Recipient Form -->
    <form *ngIf="formType === 'recipient'" [formGroup]="recipientForm" (ngSubmit)="editRecipient()">
      <mat-form-field appearance="fill">
        <mat-label>ENIS Number</mat-label>
        <input matInput formControlName="enisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
        <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('required')"> ENIS Number is required </mat-error>
        <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('pattern') && !recipientForm.get('enisNumber')?.hasError('required')"> ENIS Number must contain only digits </mat-error>
        <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('minlength') && !recipientForm.get('enisNumber')?.hasError('required') && !recipientForm.get('enisNumber')?.hasError('pattern')">
          ENIS Number must be at least 5 digits long
        </mat-error>
        <mat-error
          *ngIf="
            recipientForm.get('enisNumber')?.hasError('maxlength') &&
            !recipientForm.get('enisNumber')?.hasError('required') &&
            !recipientForm.get('enisNumber')?.hasError('pattern') &&
            !recipientForm.get('enisNumber')?.hasError('minlength')
          "
        >
          ENIS Number must be at most 6 digits long
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Date of Birth</mat-label>
        <input matInput [matDatepicker]="dobpicker2" formControlName="dob" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="dobpicker2"></mat-datepicker-toggle>
        <mat-datepicker #dobpicker2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" placeholder="firstName" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" placeholder="lastName" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Gender</mat-label>
        <mat-select matInput formControlName="gender">
          <mat-option value="M">Male</mat-option>
          <mat-option value="F">Female</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Center</mat-label>
        <mat-select formControlName="center" placeholder="Select a center">
          <mat-option *ngFor="let center of assignableCenters" [value]="center">
            {{ center.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Blood Type</mat-label>
        <mat-select matInput formControlName="abo">
          <mat-option value="O">O</mat-option>
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="AB">AB</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>HLA Class I</mat-label>
        <input matInput formControlName="abPhenotype" placeholder="A1 A1 A*01:01 A*01:01 B17 B57 B*57:01 B37 B*37:01 Bw4 Cw6 Cw6 C*06:02 C*06:02" />
        <mat-error *ngIf="recipientForm.get('abPhenotype')?.hasError('invalidPhenotype')">
          Invalid phenotype format
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>HLA Class II</mat-label>
        <input matInput formControlName="drPhenotype" placeholder="drPhenotype" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Ki-Urgency</mat-label>
        <input matInput formControlName="urgency" placeholder="Urgency" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Primary Diagnosis</mat-label>
        <input matInput formControlName="primaryDiagnosis" placeholder="Primary Diagnosis" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Date First Dialysis</mat-label>
        <input matInput [matDatepicker]="dateFirstDialysis" formControlName="dateFirstDialysis" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="dateFirstDialysis"></mat-datepicker-toggle>
        <mat-datepicker #dateFirstDialysis></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Date Screening</mat-label>
        <input matInput [matDatepicker]="dateScreening" formControlName="dateScreening" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="dateScreening"></mat-datepicker-toggle>
        <mat-datepicker #dateScreening></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Unacceptables</mat-label>
        <input matInput formControlName="unacceptables" placeholder="Unacceptables" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Returned waiting days </mat-label>
        <input matInput formControlName="previousPRA" type="number" placeholder="Returned waiting days" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Current vPRA </mat-label>
        <input matInput formControlName="virtualPRA" type="number" placeholder="Current vPRA" />
      </mat-form-field>

      <mat-checkbox
        *ngIf="!recipient?.postmortumwaitlist"
        formControlName="priority"
        [matTooltip]="!canEditPriority ? 'Centers cannot directly edit priority. Use the \'Committee request\' button instead.' : ''"
        matTooltipPosition="right">
        Priority
      </mat-checkbox>

      <mat-checkbox *ngIf="!recipient?.postmortumwaitlist" formControlName="privileges"> Privileges </mat-checkbox>

      <div *ngIf="recipientForm.get('privileges')?.value && !recipient?.postmortumwaitlist" class="additional-options">
        <br />

        <mat-form-field appearance="fill">
          <mat-label>Max Mismatches </mat-label>
          <input matInput formControlName="maxMismatches" type="number" placeholder="5" min="1" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Max mm A </mat-label>
          <input matInput formControlName="maxMmA" type="number" placeholder="2" min="0" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Max mm B </mat-label>
          <input matInput formControlName="maxMmB" type="number" placeholder="2" min="0" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Max mm DR </mat-label>
          <input matInput formControlName="maxMmDR" type="number" placeholder="2" min="0" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Max Donor Age </mat-label>
          <input matInput formControlName="maxDonorAge" type="number" placeholder="50" min="1" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Acceptable Bloodtypes </mat-label>
          <mat-select formControlName="acceptableBloodTypes" multiple>
            <mat-option value="O">O</mat-option>
            <mat-option value="A">A</mat-option>
            <mat-option value="B">B</mat-option>
            <mat-option value="AB">AB</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Low MFI unacceptables class 1 (A/B) </mat-label>
          <input matInput formControlName="lowMfi1" type="text" placeholder="" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Low MFI unacceptables class 2 (DR/DQ) </mat-label>
          <input matInput formControlName="lowMfi2" type="text" placeholder="" />
        </mat-form-field>

        <mat-form-field
          appearance="fill"
          [matTooltip]="!canEditAcceptableHla && isCenterUser ? 'Delisted Unacceptables (Priority) can only be edited once the patient has priority.' : ''"
          matTooltipPosition="right">
          <mat-label>Delisted Unacceptables (Priority) </mat-label>
          <input matInput formControlName="acceptableHla" type="text" placeholder="" />
        </mat-form-field>

        <!-- <mat-checkbox formControlName="extraWaitTime"> Extra Wait Time </mat-checkbox> -->
      </div>
      <br />
      <button mat-raised-button color="primary" type="submit">Edit Recipient</button>
    </form>
  </div>
</mat-dialog-content>
